/*
	Swagger está pronto para uso
*/
export default (state, { client, operations }) => {
	state.swagger.ready 		= true
	state.swagger.client 		= client
	state.swagger.operations 	= operations
}
	
